import { createFileRoute, redirect } from '@tanstack/react-router';
import { isWeaveTokenActive, isWeaveTokenBufferActive } from '@frontend/auth-helpers';
import { useAuthStore } from '../store/auth-store';

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    if (isWeaveTokenActive() || isWeaveTokenBufferActive()) {
      useAuthStore.getState().hydrate();
      const { hasRequiredAcl } = useAuthStore.getState();

      if (hasRequiredAcl) {
        throw redirect({ to: '/dashboard' });
      }
    }

    // Not authenticated or no ACL → login page
    throw redirect({ to: '/sign-in' });
  },
});
